<app-dialog-container [loading]="false" (closeEvent)="onDismiss()">
    <div class="is-flex align-center justify-center break-newline has-text-centered">{{data.text}}</div>
    <br />
    <div class="level is-full-width">
          <div class="level-item">
              <a class="button level-item is-primary" (click)="onDismiss()">{{data.dismissText}}</a>
          </div>
    </div>
</app-dialog-container>
